import {
	PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE,
	PUBLIC_AUTH_AMBIGUOUS_ACCESS_MESSAGE,
} from "@Front/constants/publicAuthUserMessages";

/**
 * Shared user-facing copy when customer auth returns needsChoice (ambiguous client rows).
 */
export const CUSTOMER_LOGIN_NEEDS_CHOICE_EMAIL_MESSAGE = PUBLIC_AUTH_AMBIGUOUS_ACCESS_MESSAGE;

/**
 * When public candidates return no LIVE client or third-party row for this email (and optional scope).
 */
export const CUSTOMER_LOGIN_NO_ACTIVE_ACCESS_MESSAGE = PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE;

/** Step CUSTOMER_TARGET_CHOICE — plusieurs fiches client pour le même e-mail (y compris le même dossier). */
export const CUSTOMER_TARGET_CHOICE_SUBTITLE_DEFAULT =
	"Plusieurs personnes sont enregistrées avec cet e-mail. Sélectionnez votre nom pour recevoir le code (même dossier ou dossiers distincts).";

/** Lien d’invitation avec scope : même message, précision sur le lien. */
export const CUSTOMER_TARGET_CHOICE_SUBTITLE_INVITATION_SCOPE =
	"Plusieurs personnes correspondent à ce lien pour cet e-mail. Sélectionnez votre nom pour recevoir le code.";
